import Vue from 'vue';
import VueResource from 'vue-resource';

Vue.use(VueResource);

export default {
  pagarCheckout: function (data) {
    return Vue.http.post('/api/pagamento/pagarCheckout', data);
  },
  pagarBoletoGetNet: function (data) {
    return Vue.http.post('/api/pagamento/pagarGetNetBoleto', data);
  },
  pagarCreditoGetNet: function (data) {
    return Vue.http.post('/api/pagamento/pagarGetNetCredito', data);
  },
  pagarPayPal: function (data) {
    return Vue.http.post('/api/pagamento/PagarPayPal', data);
  },
  pagarDebitoGetNet: function (data) {
    return Vue.http.post('/api/pagamento/pagarGetNetDebito', data);
  },
  pagarPix: function (data) {
    return Vue.http.post('/api/pagamento/PagarPixCobSantander', data);
  },
  verificarPagamentoPix: function (data) {
    return Vue.http.post('/api/pagamento/VerificarPixCobSantander', data);
  },
  verificarPagamento: function (data) {
    return Vue.http.post('/api/pagamento/VerificarPagamento', data);
  },
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/pagamento/servico.js